import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../../Service/axiosInstance";
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress, Alert, Box } from '@mui/material';

const items = [
  {
    title: "Hébergement",
    text: "Hôtels, locations ou chambres d’hôtes confortables, partout où vous allez."
  },
  {
    title: "Transport",
    text: "Billets d’avion, transferts et transports personnalisés avec assistance dédiée."
  },
  {
    title: "Location",
    text: "Louez des véhicules facilement pour explorer votre destination à votre rythme."
  },
  {
    title: "Activités",
    text: "Plongée, randos, visites… des expériences uniques rien que pour vous."
  },
  {
    title: "Assistance",
    text: "Conseils personnalisés, aide 24/7 et accompagnement local pour un voyage sans souci."
  }
];


const Home = () => {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [current, setCurrent] = useState(0);

  const containerStyle = {
    position: "relative",
    height: "250px",
    overflow: "hidden",
    color: "#fff"
  };

  const slideStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    opacity: 0,
    transition: "opacity 1s ease-in-out"
  };

  const activeSlideStyle = {
    ...slideStyle,
    opacity: 1,
    position: "relative"
  };

useEffect(() => {
  axiosInstance
    .get("/yourtravelshop/package/liste")
    .then((response) => {
      setPackages(response.data);
    })
    .catch((error) => {
      console.error("Erreur lors de la récupération des packages :", error);
    });
}, []);



    useEffect(() => {
    const $ = window.$ || window.jQuery;
  
    if ($ && $('.owl-carousel').length > 0) {
      $('.owl-carousel').trigger('destroy.owl.carousel'); // Nettoyage s'il y a déjà une instance
      $('.owl-carousel').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 700, 
      });
    }
  }, []);
  

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % items.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);


  const handleClickOffres = () => {
    navigate('/Offres');
  };

  return (
    <div>
      <div className="home">
  {/* Home Slider */}
  <div className="home_slider_container">
    <div className="owl-carousel owl-theme home_slider">
      {/* Slider Item */}
      <div className="owl-item home_slider_item">
        {/* Image by https://unsplash.com/@anikindimitry */}
        <div
          className="home_slider_background"
          style={{ backgroundImage: "url(assets/images/Plage.jpeg)" }}
        />
        <div className="home_slider_content text-center">
          <div
            className="home_slider_content_inner"
            data-animation-in="flipInX"
            data-animation-out="animate-out fadeOut"
          >
            <h1>Découvrir</h1>
            <h1>le monde</h1>
            <div className="button home_slider_button">
              <div className="button_bcg" />
              <a href=""onClick={handleClickOffres}>
                visiter
                <span />
                <span />
                <span />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Slider Item */}
      <div className="owl-item home_slider_item">
        <div
          className="home_slider_background"
          style={{ backgroundImage: "url(assets/images/Ambila.jpeg)" }}
        />
        <div className="home_slider_content text-center">
          <div
            className="home_slider_content_inner"
            data-animation-in="flipInX"
            data-animation-out="animate-out fadeOut"
          >
            <h1>éxplorer</h1>
            <h1>les horizons</h1>

            <div className="button home_slider_button">
              <div className="button_bcg" />
              <a href="" onClick={handleClickOffres}>
              visiter
                <span />
                <span />
                <span />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Slider Item */}
      <div className="owl-item home_slider_item">
        <div
          className="home_slider_background"
          style={{ backgroundImage: "url(assets/images/Mantasoa.jpeg)" }}
        />
        <div className="home_slider_content text-center">
          <div
            className="home_slider_content_inner"
            data-animation-in="flipInX"
            data-animation-out="animate-out fadeOut"
          >
          <h1>vivre</h1>
          <h1>des aventures</h1>

            <div className="button home_slider_button">
              <div className="button_bcg" />
              <a href="" onClick={handleClickOffres}>
              visiter
                <span />
                <span />
                <span />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
</div>

<div className="cta" style={{  height: "300px", // hauteur réduite
    display: "flex",
    alignItems: "center", // centrage vertical
    justifyContent: "center", // centrage horizontal
    position: "relative",
    overflow: "hidden" }} >
      <div
        className="cta_background"
        style={{ backgroundImage: "url(/assets/images/cta.jpg)" }}
      />

      <div className="container">
        <div className="row">
          <div className="col text-center">
            <div style={containerStyle}>
              {items.map((item, index) => (
                <div
                  key={index}
                  style={current === index ? activeSlideStyle : slideStyle}
                >
                <div 
                style={{
                  fontFamily: 'Beyond',
                  fontSize: '50px',
                  color: '#000000'
                }}
              >
                {item.title}
              </div>

              <div className="rating_r rating_r_4" style={{ marginTop: '15px' }}>
                <i /><i /><i /><i /><i />
              </div>

                  <p
                      className="cta_text"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "12px",
                        borderRadius: "8px",
                        color: "#fff",
                        fontSize: "16px",
                        maxWidth: "600px",
                        margin: "20px auto",
                        lineHeight: "1.5"
                      }}
                    >
                      {item.text}
                    </p>

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>


      {/* Offers Section */}
  <div className="offers">
    <div className="container">
      <div className="row">
        <div className="col text-center">
        <h2 style={{
          fontFamily: 'Beyond',
          fontSize: '50px',
          color: '#000000',
        }}>
          Nos meilleurs offres
        </h2>
        </div>
      </div>
      <div className="row offers_items">
        {packages.map((pkg) => (
          <div className="col-lg-6 offers_col" key={pkg.idPackage}>
            <div className="offers_item">
              <div className="row">
                <div className="col-lg-6">
                  <div className="offers_image_container">
                    <div
                      className="offers_image_background"
                      style={{
                        backgroundImage: pkg.prospectusPhoto
                          ? `url(${pkg.prospectusPhoto.stockage})`
                          : "url('default-image.jpg')", // Utiliser une image par défaut si l'URL de l'image est nulle
                      }}
                    />
                    <div className="offer_name" style={{ width: 'fit-content'}}>
  			<a href="#">{pkg.nom}</a>
			</div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="offers_content">
                    <div className="offers_price">
                      {pkg.prix} <span> Ariary</span>
                    </div>
                    <div className="rating_r rating_r_4 offers_rating">
                      <i />
                      <i />
                      <i />
                      <i />
                      <i />
                    </div>
                    <p className="offers_text">
                      {pkg.description}
                    </p>
                    <div className="button button_1 offers_button">
                    <Button
                      variant="contained"
                      onClick={() => navigate(`/Package-details/${pkg.idPackage}`)}
                      style={{
                        backgroundColor: '#8a2be2',  // Violet
                        color: 'white',              // Texte blanc
                        fontWeight: 'bold',          // Texte en gras
                        padding: '10px 20px',        // Espacement interne
                        borderRadius: '15px',         // Coins arrondis
                      }}
                    >
                      Voir Détails
                    </Button>


                    
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>





    </div>
  );
};

export default Home;
